import { Project, Issue, User, Sprint, Board, BoardColumn } from '../types';

import { Project, Issue, User, Sprint, Board, BoardColumn, Message, IssueChat, ChatMessage } from '../types';

// Keep users for fallback and demo purposes
export const users: User[] = [
  {
    id: '1',
    accountId: 'acc-001',
    displayName: 'Sarah Chen',
    emailAddress: 'sarah.chen@company.com',
    avatarUrl: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&dpr=2',
    active: true,
    timeZone: 'America/New_York',
    locale: 'en_US',
    groups: ['jira-administrators', 'developers']
  },
  {
    id: '2',
    accountId: 'acc-002',
    displayName: 'Marcus Johnson',
    emailAddress: 'marcus.johnson@company.com',
    avatarUrl: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&dpr=2',
    active: true,
    timeZone: 'America/New_York',
    locale: 'en_US',
    groups: ['developers']
  },
  {
    id: '3',
    accountId: 'acc-003',
    displayName: 'Elena Rodriguez',
    emailAddress: 'elena.rodriguez@company.com',
    avatarUrl: 'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&dpr=2',
    active: true,
    timeZone: 'America/Los_Angeles',
    locale: 'en_US',
    groups: ['designers']
  },
  {
    id: '4',
    accountId: 'acc-004',
    displayName: 'David Kim',
    emailAddress: 'david.kim@company.com',
    avatarUrl: 'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&dpr=2',
    active: true,
    timeZone: 'Asia/Seoul',
    locale: 'ko_KR',
    groups: ['developers', 'qa']
  }
];

// Keep other mock data for fallback purposes
export const projects: Project[] = [
  {
    id: '1',
    key: 'ECOM',
    name: 'E-commerce Platform',
    description: 'Next-generation e-commerce platform with modern architecture',
    type: 'software',
    lead: '1',
    category: 'Development',
    avatar: '🛒',
    teamMembers: ['1', '2', '4'],
    startDate: '2024-01-15',
    endDate: '2024-06-15',
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-01-20T00:00:00Z'
  },
  {
    id: '2',
    key: 'MOB',
    name: 'Mobile Application',
    description: 'Cross-platform mobile app for iOS and Android',
    type: 'software',
    lead: '2',
    category: 'Mobile',
    avatar: '📱',
    teamMembers: ['2', '3'],
    startDate: '2024-02-01',
    endDate: '2024-08-01',
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-02-05T00:00:00Z'
  },
  {
    id: '3',
    key: 'DASH',
    name: 'Analytics Dashboard',
    description: 'Real-time business intelligence dashboard',
    type: 'business',
    lead: '3',
    category: 'Analytics',
    avatar: '📊',
    teamMembers: ['1', '3', '4'],
    startDate: '2024-03-01',
    endDate: '2024-09-01',
    createdAt: '2024-03-01T00:00:00Z',
    updatedAt: '2024-03-05T00:00:00Z'
  }
];

export const messages: Message[] = [
  {
    id: '1',
    issueId: '1',
    userId: '1',
    content: 'I\'ve started working on the authentication system. The OAuth 2.0 implementation is in progress.',
    timestamp: '2024-01-16T10:30:00Z',
    type: 'text'
  },
  {
    id: '2',
    issueId: '1',
    userId: '2',
    content: 'Great! Make sure to include proper error handling for failed authentication attempts.',
    timestamp: '2024-01-16T11:15:00Z',
    type: 'text'
  },
  {
    id: '3',
    issueId: '3',
    userId: '4',
    content: 'I\'ve identified the issue with the discount code calculation. Working on a fix now.',
    timestamp: '2024-01-18T14:20:00Z',
    type: 'text'
  }
];

export const boardColumns: BoardColumn[] = [
  { id: 'col-1', name: 'To Do', statuses: ['to-do', 'backlog'] },
  { id: 'col-2', name: 'In Progress', statuses: ['in-progress'] },
  { id: 'col-3', name: 'In Review', statuses: ['in-review'] },
  { id: 'col-4', name: 'Done', statuses: ['done'] }
];

export const boards: Board[] = [
  {
    id: '1',
    name: 'ECOM Board',
    type: 'scrum',
    projectId: '1',
    columns: boardColumns,
    filter: 'project = ECOM',
    administrators: ['1']
  },
  {
    id: '2',
    name: 'MOB Kanban',
    type: 'kanban',
    projectId: '2',
    columns: boardColumns,
    filter: 'project = MOB',
    administrators: ['2']
  }
];

export const sprints: Sprint[] = [
  {
    id: '1',
    name: 'Sprint 1',
    goal: 'Complete user authentication and basic UI',
    state: 'active',
    projectId: '1',
    duration: 2,
    priority: 'high',
    description: 'Focus on core authentication features and basic user interface components',
    teamMembers: ['1', '2', '4'],
    createdBy: '1',
    capacity: 40,
    capacityType: 'story-points',
    startDate: '2024-01-15T00:00:00Z',
    endDate: '2024-01-29T00:00:00Z',
    createdAt: '2024-01-10T00:00:00Z',
    updatedAt: '2024-01-15T00:00:00Z',
    boardId: '1',
    issues: ['ECOM-1', 'ECOM-2', 'ECOM-3']
  },
  {
    id: '2',
    name: 'Sprint 2',
    goal: 'Implement product catalog and search',
    state: 'future',
    projectId: '1',
    duration: 2,
    priority: 'medium',
    description: 'Build product listing, filtering, and search functionality',
    teamMembers: ['1', '2', '3'],
    createdBy: '1',
    capacity: 35,
    capacityType: 'story-points',
    startDate: '2024-01-30T00:00:00Z',
    endDate: '2024-02-13T00:00:00Z',
    createdAt: '2024-01-10T00:00:00Z',
    updatedAt: '2024-01-10T00:00:00Z',
    boardId: '1',
    issues: ['ECOM-4', 'ECOM-5']
  },
  {
    id: '3',
    name: 'Mobile Sprint 1',
    goal: 'Mobile app foundation and navigation',
    state: 'future',
    projectId: '2',
    duration: 3,
    priority: 'high',
    description: 'Set up mobile app architecture and implement core navigation',
    teamMembers: ['2', '3'],
    createdBy: '2',
    capacity: 25,
    capacityType: 'story-points',
    startDate: '2024-02-05T00:00:00Z',
    endDate: '2024-02-26T00:00:00Z',
    createdAt: '2024-01-20T00:00:00Z',
    updatedAt: '2024-01-20T00:00:00Z',
    boardId: '2',
    issues: ['MOB-1']
  }
];

export const issues: Issue[] = [
  {
    id: '1',
    key: 'ECOM-1',
    projectId: '1',
    summary: 'Implement user authentication system',
    description: 'Create a secure user authentication system with login, registration, and password reset functionality.',
    type: 'story',
    status: 'in-progress',
    priority: 'high',
    assignee: '2',
    assignees: ['2', '4'],
    reporter: '1',
    labels: ['authentication', 'security'],
    components: ['Backend', 'Frontend'],
    fixVersions: ['1.0.0'],
    storyPoints: 8,
    originalEstimate: '2w',
    timeSpent: '1w 2d',
    remainingEstimate: '3d',
    createdAt: '2024-01-15T09:00:00Z',
    updatedAt: '2024-01-20T14:30:00Z',
    dueDate: '2024-01-25T00:00:00Z',
    sprint: '1',
    subtasks: [],
    attachments: [],
    assignmentHistory: [
      {
        id: '1',
        issueId: '1',
        userId: '2',
        assignedBy: '1',
        action: 'assigned',
        timestamp: '2024-01-15T09:00:00Z',
        reason: 'Initial assignment'
      },
      {
        id: '2',
        issueId: '1',
        userId: '4',
        assignedBy: '1',
        action: 'assigned',
        timestamp: '2024-01-16T10:00:00Z',
        reason: 'Added for QA support'
      }
    ],
    chatId: 'chat-1',
    comments: [
      {
        id: '1',
        author: '1',
        body: 'Please ensure we follow OAuth 2.0 standards for this implementation.',
        created: '2024-01-16T10:00:00Z',
        updated: '2024-01-16T10:00:00Z'
      }
    ],
    worklog: [
      {
        id: '1',
        author: '2',
        comment: 'Working on login API endpoints',
        timeSpent: '4h',
        started: '2024-01-16T09:00:00Z',
        created: '2024-01-16T13:00:00Z',
        updated: '2024-01-16T13:00:00Z'
      }
    ]
  },
  {
    id: '2',
    key: 'ECOM-2',
    projectId: '1',
    summary: 'Design product listing page',
    description: 'Create wireframes and mockups for the product listing page with filtering and sorting capabilities.',
    type: 'task',
    status: 'done',
    priority: 'medium',
    assignee: '3',
    assignees: ['3'],
    reporter: '1',
    labels: ['design', 'ui'],
    components: ['Frontend'],
    fixVersions: ['1.0.0'],
    storyPoints: 5,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-18T16:00:00Z',
    resolution: 'Done',
    sprint: '1',
    subtasks: [],
    attachments: [],
    assignmentHistory: [
      {
        id: '3',
        issueId: '2',
        userId: '3',
        assignedBy: '1',
        action: 'assigned',
        timestamp: '2024-01-15T10:00:00Z'
      }
    ],
    chatId: 'chat-2',
    comments: [],
    worklog: []
  },
  {
    id: '3',
    key: 'ECOM-3',
    projectId: '1',
    summary: 'Fix checkout process bug',
    description: 'Users are unable to complete checkout when using discount codes. The total calculation is incorrect.',
    type: 'bug',
    status: 'to-do',
    priority: 'highest',
    assignee: '4',
    assignees: ['4', '2'],
    reporter: '2',
    labels: ['bug', 'checkout'],
    components: ['Backend'],
    fixVersions: ['1.0.1'],
    storyPoints: 3,
    createdAt: '2024-01-18T11:00:00Z',
    updatedAt: '2024-01-18T11:00:00Z',
    dueDate: '2024-01-22T00:00:00Z',
    sprint: '1',
    subtasks: [],
    attachments: [],
    assignmentHistory: [
      {
        id: '4',
        issueId: '3',
        userId: '4',
        assignedBy: '2',
        action: 'assigned',
        timestamp: '2024-01-18T11:00:00Z'
      },
      {
        id: '5',
        issueId: '3',
        userId: '2',
        assignedBy: '2',
        action: 'assigned',
        timestamp: '2024-01-18T12:00:00Z',
        reason: 'Backend expertise needed'
      }
    ],
    chatId: 'chat-3',
    comments: [],
    worklog: []
  },
  {
    id: '4',
    key: 'MOB-1',
    projectId: '2',
    summary: 'Mobile app navigation structure',
    description: 'Define and implement the main navigation structure for the mobile application.',
    type: 'story',
    status: 'in-review',
    priority: 'high',
    assignee: '2',
    assignees: ['2', '3'],
    reporter: '1',
    labels: ['mobile', 'navigation'],
    components: ['Mobile'],
    fixVersions: ['1.0.0'],
    storyPoints: 5,
    createdAt: '2024-02-01T09:00:00Z',
    updatedAt: '2024-02-03T14:00:00Z',
    subtasks: [],
    attachments: [],
    assignmentHistory: [
      {
        id: '6',
        issueId: '4',
        userId: '2',
        assignedBy: '1',
        action: 'assigned',
        timestamp: '2024-02-01T09:00:00Z'
      },
      {
        id: '7',
        issueId: '4',
        userId: '3',
        assignedBy: '1',
        action: 'assigned',
        timestamp: '2024-02-02T10:00:00Z',
        reason: 'Design review needed'
      }
    ],
    chatId: 'chat-4',
    comments: [],
    worklog: []
  },
  {
    id: '5',
    key: 'DASH-1',
    projectId: '3',
    summary: 'Create data visualization components',
    description: 'Build reusable chart components for the analytics dashboard.',
    type: 'task',
    status: 'on-hold',
    priority: 'medium',
    assignee: '3',
    assignees: ['3'],
    reporter: '1',
    labels: ['charts', 'components'],
    components: ['Frontend'],
    fixVersions: ['1.0.0'],
    storyPoints: 8,
    estimationTime: 24,
    createdAt: '2024-03-01T10:00:00Z',
    updatedAt: '2024-03-01T10:00:00Z',
    subtasks: [],
    attachments: [],
    assignmentHistory: [
      {
        id: '8',
        issueId: '5',
        userId: '3',
        assignedBy: '1',
        action: 'assigned',
        timestamp: '2024-03-01T10:00:00Z'
      }
    ],
    chatId: 'chat-5',
    comments: [],
    worklog: []
  }
]

export const issueChats: IssueChat[] = [
  {
    id: 'chat-1',
    issueId: '1',
    participants: ['1', '2', '4'],
    messages: [
      {
        id: 'msg-1',
        chatId: 'chat-1',
        userId: '1',
        content: 'Starting work on the authentication system. @marcus @david please review the requirements.',
        timestamp: '2024-01-15T09:30:00Z',
        type: 'text',
        mentions: ['2', '4']
      },
      {
        id: 'msg-2',
        chatId: 'chat-1',
        userId: '2',
        content: 'Looks good! I\'ll handle the backend API implementation.',
        timestamp: '2024-01-15T10:15:00Z',
        type: 'text'
      },
      {
        id: 'msg-3',
        chatId: 'chat-1',
        userId: '4',
        content: 'I\'ll prepare the QA test cases for the authentication flow.',
        timestamp: '2024-01-15T11:00:00Z',
        type: 'text'
      }
    ],
    createdAt: '2024-01-15T09:00:00Z',
    updatedAt: '2024-01-15T11:00:00Z',
    isActive: true
  },
  {
    id: 'chat-2',
    issueId: '2',
    participants: ['1', '3'],
    messages: [
      {
        id: 'msg-4',
        chatId: 'chat-2',
        userId: '1',
        content: 'Elena, please create wireframes for the product listing page.',
        timestamp: '2024-01-15T10:30:00Z',
        type: 'text'
      },
      {
        id: 'msg-5',
        chatId: 'chat-2',
        userId: '3',
        content: 'Wireframes completed and uploaded.',
        timestamp: '2024-01-16T14:00:00Z',
        type: 'text'
      }
    ],
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-16T14:00:00Z',
    isActive: true
  },
  {
    id: 'chat-3',
    issueId: '3',
    participants: ['2', '4'],
    messages: [
      {
        id: 'msg-6',
        chatId: 'chat-3',
        userId: '2',
        content: 'Found the issue with discount code calculation. @david can you help test this?',
        timestamp: '2024-01-18T13:00:00Z',
        type: 'text',
        mentions: ['4']
      },
      {
        id: 'msg-7',
        chatId: 'chat-3',
        userId: '4',
        content: 'Sure! I\'ll test it right away.',
        timestamp: '2024-01-18T13:15:00Z',
        type: 'text'
      }
    ],
    createdAt: '2024-01-18T11:00:00Z',
    updatedAt: '2024-01-18T13:15:00Z',
    isActive: true
  }
];